import Base from '../Base';
import styles from './Contact.module.scss';

const Contact = () => {
  return (
    <Base>
      <div className={styles.root}>
        <iframe
          src='https://calendar.google.com/calendar/appointments/schedules/AcZssZ0qPiI47FpT4eT0jN1AGF95HJ0N5cReAKL_hT-e2XslwkVALmjF59kATt_kkjClf6RuwDLczccT?gv=true'
          title='Google Calendar'>
        </iframe>
      </div>
    </Base>
  );
};

export default Contact;